export const SocialPlatformEnum = {
    FACEBOOK: 'facebook',
    GOOGLE_MY_BUSINESS: 'googleMyBusiness',
    INSTAGRAM: 'instagram',
    LINKEDIN: 'linkedIn',
} as const;
